/**
 * Product Lollipop SEO V5 - External JavaScript
 * ==============================================
 * Externalisé pour améliorer les performances (cache, TTFB, FCP)
 * CORRIGÉ: Sélecteurs alignés avec le HTML de la section
 * CORRIGÉ: Cart drawer refresh via Sections API (Dawn compatible)
 */

(function () {
  'use strict';

  // Prevent double initialization
  if (window.lp9ProductInitialized) return;
  window.lp9ProductInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    // ═══════════════════════════════════════════════════════
    // PROGRESS BAR LIVRAISON - Init avec animation au load
    // ═══════════════════════════════════════════════════════
    // Seuil piloté par settings.free_shipping_threshold via data-threshold
    // sur #lp9Shipping (source unique). Fallback : 3900 = 39€ en centimes.
    var lp9ShippingWrap = document.getElementById('lp9Shipping');
    var threshold = (lp9ShippingWrap && parseInt(lp9ShippingWrap.getAttribute('data-threshold'), 10)) || 3900;

    var updateShippingBar = function () {
      var fillEl = document.getElementById('lp9ShippingFill');
      var textEl = document.getElementById('lp9ShippingText');
      var wrapperEl = document.getElementById('lp9Shipping');
      var cartTotalEl = document.getElementById('lp9CartTotal');
      if (!fillEl || !textEl) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price || 0;
          var remaining = threshold - total;
          var pct = Math.min(100, (total / threshold) * 100);
          fillEl.style.width = pct + '%';

          if (cartTotalEl) {
            cartTotalEl.textContent = (total / 100).toFixed(2).replace('.', ',') + '€';
          }

          if (remaining <= 0) {
            textEl.innerHTML = '🎉 <strong>Livraison OFFERTE</strong> débloquée !';
            if (wrapperEl) wrapperEl.classList.add('lp9-shipping--unlocked');
          } else {
            var euros = (remaining / 100).toFixed(2).replace('.', ',');
            textEl.innerHTML = 'Plus que <strong>' + euros + ' €</strong> pour la livraison offerte';
            if (wrapperEl) wrapperEl.classList.remove('lp9-shipping--unlocked');
          }
        })
        .catch(function () { });
    };

    setTimeout(updateShippingBar, 300);
    document.addEventListener('cart:refresh', updateShippingBar);

    // ═══════════════════════════════════════════════════════
    // DELIVERY ESTIMATE - Calcule la date de livraison estimée
    // ═══════════════════════════════════════════════════════
    var addBusinessDays = function (date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dayOfWeek = result.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) added++;
      }
      return result;
    };

    var calculateDeliveryEstimate = function () {
      var today = new Date();
      var minDate = addBusinessDays(today, 3);
      var maxDate = addBusinessDays(today, 5);
      var options = { day: 'numeric', month: 'long' };
      var minStr = minDate.toLocaleDateString('fr-FR', options);
      var maxStr = maxDate.toLocaleDateString('fr-FR', options);

      // Si même mois, afficher "14-16 janvier" sinon "30 janvier - 2 février"
      if (minDate.getMonth() === maxDate.getMonth()) {
        return '📦 Livraison estimée: ' + minDate.getDate() + '-' + maxStr;
      } else {
        return '📦 Livraison estimée: ' + minStr + ' - ' + maxStr;
      }
    };

    var deliveryEstimate = calculateDeliveryEstimate();
    ['lp9DeliveryEstimate', 'lp9DeliveryEstimateLow', 'lp9DeliveryEstimateNoStock'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = deliveryEstimate;
    });

    // ═══════════════════════════════════════════════════════
    // HOOKS TOGGLE - Bouton "Voir les détails"
    // ═══════════════════════════════════════════════════════
    document.querySelectorAll('[data-toggle="hooks"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var more = document.querySelector('[data-more="hooks"]');
        if (!more) return;
        var isHidden = more.hasAttribute('hidden');
        if (isHidden) {
          more.removeAttribute('hidden');
          btn.textContent = 'Masquer ▲';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          more.setAttribute('hidden', '');
          btn.textContent = 'Voir les détails ▼';
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // ═══════════════════════════════════════════════════════
    // STICKY FOOTER - IntersectionObserver
    // ═══════════════════════════════════════════════════════
    // Sticky ATC mobile — toggle au scroll (re-query chaque tick : survit aux
    // re-rendus de section ; l'IntersectionObserver historique ne déclenchait pas).
    var lp9StickyTick = false;
    var lp9StickyUpdate = function () {
      lp9StickyTick = false;
      var bar = document.getElementById('lp9Sticky');
      if (!bar) return;
      var cta = document.querySelector('.lp9-cta.js-add');
      var show;
      if (cta) {
        show = cta.getBoundingClientRect().bottom < 0;
      } else {
        show = window.scrollY > 600;
      }
      var drawerOpen = document.querySelector('cart-drawer.active, cart-drawer.animate');
      bar.classList.toggle('visible', !!show && !drawerOpen);
    };
    window.addEventListener('scroll', function () {
      if (!lp9StickyTick) { lp9StickyTick = true; setTimeout(lp9StickyUpdate, 80); }
    }, { passive: true });
    setTimeout(lp9StickyUpdate, 400);

    // ═══════════════════════════════════════════════════════
    // GALERIE — vignettes cliquables (swap image principale)
    // ═══════════════════════════════════════════════════════
    var lp9Thumbs = document.querySelectorAll('.lp9-thumb');
    var lp9Main = document.getElementById('lp9MainImg');
    if (lp9Thumbs.length && lp9Main) {
      lp9Thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full) { lp9Main.removeAttribute('srcset'); lp9Main.src = full; }
          lp9Thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }

    // ═══════════════════════════════════════════════════════
    // QUANTITY BUTTONS
    // ═══════════════════════════════════════════════════════
    var qtyContainer = document.querySelector('.lp9-qty');
    if (qtyContainer) {
      var input = qtyContainer.querySelector('input.js-q');
      var minusBtn = qtyContainer.querySelector('.js-qm');
      var plusBtn = qtyContainer.querySelector('.js-qp');

      if (minusBtn && plusBtn && input) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        plusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }


    // ═══════════════════════════════════════════════════════
    // TOAST & CONFETTI
    // ═══════════════════════════════════════════════════════
    var toastEl = document.getElementById('lp9Toast');
    var confettiEl = document.getElementById('lp9Confetti');

    var toast = function () {
      if (!toastEl) return;
      toastEl.classList.add('show');
      setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
    };

    var confetti = function () {
      if (!confettiEl) return;
      var emoji = ['🍭', '🎀', '💖', '✨', '🌸'];
      for (var i = 0; i < 18; i++) {
        var el = document.createElement('i');
        el.textContent = emoji[Math.floor(Math.random() * emoji.length)];
        el.style.left = (Math.random() * 100) + '%';
        el.style.top = (Math.random() * 40 + 20) + '%';
        el.style.fontSize = (Math.random() * 14 + 14) + 'px';
        confettiEl.appendChild(el);
        setTimeout(function (e) { e.remove(); }, 1200, el);
      }
    };

    // ═══════════════════════════════════════════════════════
    // OPEN CART DRAWER - Compatible Dawn/Shopify themes
    // ═══════════════════════════════════════════════════════
    var openCartDrawer = function () {
      var cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        // Fetcher la section cart-drawer mise à jour
        fetch(window.Shopify.routes.root + 'cart?section_id=cart-drawer')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Mettre à jour le contenu du drawer
            var newDrawerContent = doc.querySelector('#CartDrawer');
            var currentDrawer = document.getElementById('CartDrawer');
            if (newDrawerContent && currentDrawer) {
              currentDrawer.innerHTML = newDrawerContent.innerHTML;
            }

            // Mettre à jour l'icône du panier
            var newBubble = doc.querySelector('#cart-icon-bubble');
            var currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }

            // Ouvrir le drawer
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }

            // Réattacher l'event overlay
            var overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay) {
              overlay.addEventListener('click', function () {
                cartDrawer.close();
              });
            }
          })
          .catch(function (e) {
            console.error('Erreur refresh cart drawer:', e);
            // Fallback: ouvrir quand même
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          });
      } else {
        // Pas de cart-drawer, essayer cart-notification
        var cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
        }
      }

      // Publier l'event pour les autres composants
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      }
    };

    // ═══════════════════════════════════════════════════════
    // ADD TO CART (Main CTA)
    // ═══════════════════════════════════════════════════════
    var form = document.querySelector('.js-lp9-form');
    var ctaButton = document.querySelector('.lp9-cta.js-add');

    if (form && ctaButton) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (ctaButton.dataset.loading === '1') return;
        ctaButton.dataset.loading = '1';

        var variantId = form.querySelector('input[name="id"]').value;
        var qty = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;

        var originalHTML = ctaButton.innerHTML;
        ctaButton.disabled = true;
        ctaButton.innerHTML = '⏳ Ajout...';
        ctaButton.classList.add('pulse');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            ctaButton.innerHTML = '✅ Ajouté !';
            toast();
            confetti();
            setTimeout(updateShippingBar, 500);

            document.dispatchEvent(new CustomEvent('product:added-to-cart', {
              detail: { product: data }
            }));

            // Ouvrir le cart drawer avec refresh
            setTimeout(openCartDrawer, 100);

            setTimeout(function () {
              ctaButton.innerHTML = originalHTML;
              ctaButton.disabled = false;
              ctaButton.dataset.loading = '0';
            }, 2000);
          })
          .catch(function () {
            ctaButton.innerHTML = '❌ Erreur';
            alert("Impossible d'ajouter. Réessaie.");
            setTimeout(function () {
              ctaButton.innerHTML = originalHTML;
              ctaButton.disabled = false;
              ctaButton.dataset.loading = '0';
            }, 2000);
          })
          .finally(function () {
            setTimeout(function () { ctaButton.classList.remove('pulse'); }, 600);
          });
      });
    }

    // ═══════════════════════════════════════════════════════
    // STICKY FOOTER ADD BUTTON
    // ═══════════════════════════════════════════════════════
    var stickyAddBtn = document.getElementById('lp9StickyAdd');
    if (stickyAddBtn && form) {
      stickyAddBtn.addEventListener('click', function () {
        var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
      });
    }

    // ═══════════════════════════════════════════════════════
    // PACK ADD BUTTON
    // ═══════════════════════════════════════════════════════
    var packBtn = document.querySelector('.js-pack-add');
    if (packBtn) {
      packBtn.addEventListener('click', function () {
        if (packBtn.dataset.loading === '1') return;
        packBtn.dataset.loading = '1';

        var box = document.getElementById('lp9Pack');
        if (!box) { packBtn.dataset.loading = '0'; return; }

        var mainEl = box.querySelector('[data-main-variant]');
        var packEls = Array.prototype.slice.call(box.querySelectorAll('[data-pack-variant]'));

        var mainVariantId = mainEl ? parseInt(mainEl.getAttribute('data-main-variant'), 10) : null;
        var packVariantIds = packEls
          .map(function (el) { return parseInt(el.getAttribute('data-pack-variant'), 10); })
          .filter(function (n) { return Number.isFinite(n); });

        if (!mainVariantId || packVariantIds.length === 0) { packBtn.dataset.loading = '0'; return; }

        var originalText = packBtn.textContent;
        packBtn.disabled = true;
        packBtn.textContent = '⏳ Ajout en cours...';
        packBtn.classList.add('pulse');

        var items = [{ id: mainVariantId, quantity: 1 }].concat(
          packVariantIds.slice(0, 2).map(function (id) { return { id: id, quantity: 1 }; })
        );

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            packBtn.textContent = '✅ Pack ajouté !';
            toast();
            confetti();
            setTimeout(updateShippingBar, 500);

            document.dispatchEvent(new CustomEvent('product:added-to-cart', {
              detail: { product: data, isBundle: true }
            }));

            setTimeout(openCartDrawer, 100);

            setTimeout(function () {
              packBtn.textContent = originalText;
              packBtn.disabled = false;
              packBtn.dataset.loading = '0';
            }, 2000);
          })
          .catch(function () {
            packBtn.textContent = '❌ Erreur';
            alert("Impossible d'ajouter le pack. Réessaie.");
            setTimeout(function () {
              packBtn.textContent = originalText;
              packBtn.disabled = false;
              packBtn.dataset.loading = '0';
            }, 2000);
          })
          .finally(function () {
            setTimeout(function () { packBtn.classList.remove('pulse'); }, 600);
          });
      });
    }

    // ═══════════════════════════════════════════════════════
    // RESTOCK FORM
    // ═══════════════════════════════════════════════════════
    var restockForm = document.getElementById('lp9RestockForm');
    if (restockForm) {
      restockForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = restockForm.querySelector('input[name="email"]').value;
        var variantId = restockForm.querySelector('input[name="variant_id"]').value;
        var productTitle = restockForm.querySelector('input[name="product_title"]').value;

        var btn = restockForm.querySelector('.lp9-restock-btn');
        var originalText = btn.textContent;
        btn.textContent = '✅ Inscrit !';
        btn.disabled = true;

        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          restockForm.reset();
        }, 3000);

        console.log('Restock alert:', { email: email, variantId: variantId, productTitle: productTitle });
      });
    }
  });

  // ═══════════════════════════════════════════════════════
  // Section Rendering API Support (Theme Editor)
  // ═══════════════════════════════════════════════════════
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.lp9')) {
      window.lp9ProductInitialized = false;
      document.dispatchEvent(new Event('DOMContentLoaded'));
    }
  });
})();
